import { Locale, Translation } from 'locale'
import React, { useState } from 'react'
import { DialogRow } from 'view/components/inputs'
import { TradingDatePickerField } from 'view/shared/entity'
import { ValidationIssuesContainer } from 'view/shared/error'
import { FieldsContainer, TableCell, TableCellInput } from '../servicingDialogStyles'
import * as constants from 'view/styles/constants'
import { DateLike, toLocalDateString } from 'utils'
import { useSelector } from 'react-redux'
import { platformTradeDateSelector } from 'selectors/platformSelectors'
import { getDateEditorFormat } from 'model'
import { Currency, DealDetail } from 'api'
import { isNil } from 'lodash'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { useDealDetailsEffectiveDateInfo } from '../useGetEffectiveDateInfo'
import { useUserPreference } from 'view/hooks'

interface SetAllEffectiveDatesProps {
  dealDetails: DealDetail[]
  extendMaturityDate?: boolean
  onApply: (effectiveDate: DateLike | null) => void
}

export const SetAllEffectiveDates: React.FC<SetAllEffectiveDatesProps> = ({ dealDetails, extendMaturityDate = false, onApply }) => {
  const platformTradeDate = useSelector(platformTradeDateSelector)
  const userPreference = useUserPreference()

  const firstDealDetail = dealDetails[0] ? dealDetails[0] : null
  const currency = firstDealDetail?.deal?.currency ?? Currency.EUR

  const [effectiveDate, setEffectiveDate] = useState<DateLike | null>(
    typeof platformTradeDate === 'string' ? platformTradeDate : toLocalDateString(platformTradeDate)
  )
  const dateEditorFormat = getDateEditorFormat(userPreference.dateFormat)
  const { minEffectiveDate, maxEffectiveDate, isBeforeCutOffTime } = useDealDetailsEffectiveDateInfo(dealDetails, extendMaturityDate)

  return (
    <FieldsContainer>
      {!isBeforeCutOffTime && (
        <ValidationIssuesContainer>
          {<li>{Locale.translate(Translation.SC_REQUEST_INITIATED_AFTER_CUT_OFF_TIME)}</li>}
        </ValidationIssuesContainer>
      )}
      <DialogRow verticalLayout={constants.VerticalLayout.Center}>
        <TableCell>{Locale.translate(Translation.SC_SET_ALL_EFFECTIVE_DATES)}</TableCell>
        <TableCellInput>
          <TradingDatePickerField
            dataTestId={'TradingDatePicker'}
            label={''}
            currency={currency}
            minDate={minEffectiveDate ?? undefined}
            maxDate={maxEffectiveDate ?? undefined}
            dateFormat={dateEditorFormat}
            value={effectiveDate}
            onUpdate={(value: DateLike | null) => {
              setEffectiveDate(value)
            }}
          />
        </TableCellInput>
        <TableCell>
          <TextButton type={TextButtonType.Primary} disabled={isNil(effectiveDate)} onClick={() => onApply(effectiveDate)}>
            {Locale.translate(Translation.TC_BUTTON_APPLY)}
          </TextButton>
        </TableCell>
        <TableCell>{Locale.translate(Translation.SC_OR_ENTER_MANUALLY)}</TableCell>
      </DialogRow>
    </FieldsContainer>
  )
}
